// EBM: turn Instafeed posts on the homepage into small cards with a caption row.
// The Instafeed app keeps the caption only in the image alt text
// ("Instagram post with the caption: ..."), so it is copied into a
// <p class="ebm-ig-caption"> inside each post tile. Idempotent; re-runs when the
// app (re)renders its grid (it renders asynchronously and again on resize).
(() => {
  const PREFIX = /^\s*Instagram post with the caption:\s*/i;
  const SECTION = "[id$='__17857192268734da5f']";

  const enhance = (root) => {
    root.querySelectorAll('.instafeed-new-layout-item').forEach((item) => {
      if (item.querySelector(':scope > .ebm-ig-caption')) return;
      const img = item.querySelector(':scope > img');
      // The app double-escapes entities in the alt ("&amp;"); decode them as text.
      const decoder = document.createElement('textarea');
      decoder.innerHTML = img && img.alt ? img.alt : '';
      const text = decoder.value.replace(PREFIX, '').replace(/\s*(\.\.\.|…)\s*$/, '…').trim();
      if (!text) return;
      const p = document.createElement('p');
      p.className = 'ebm-ig-caption';
      p.setAttribute('aria-hidden', 'true'); // the image alt already carries the caption
      p.textContent = text;
      item.appendChild(p);
      item.classList.add('ebm-ig-card');
    });
  };

  const start = () => {
    const section = document.querySelector(SECTION);
    if (!section) return;
    enhance(section);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        enhance(section);
      });
    }).observe(section, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
